import React from 'react';
import ReactDOM from 'react-dom/client';
import AdminPanelApp from './components/AdminPanelApp';
import './index.css';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);
root.render(
  <React.StrictMode>
    <AdminPanelApp />
  </React.StrictMode>,
);
